export default "__VITE_ASSET__CFZMU5g8__"